// Helpers for excluding already-chosen records from content-search results.
//
// Some call-sites (e.g. scope position editing) reset the search model on
// every pick, so content-search's own de-dupe against its `model` can't see
// what's already been added. Those call-sites instead pass the current
// selection via the `exclude` prop and we filter it out of the options here.

// Build a Set of ids from a list of records and/or bare id strings.
export function excludeIdSet(exclude) {
  const ids = new Set();
  (exclude || []).forEach(function (entry) {
    const id = typeof entry === "string" ? entry : entry?._id;
    if (id) {
      ids.add(id);
    }
  });
  return ids;
}

// Filter options down to those not present in `exclude`. Returns the original
// list reference when there is nothing to exclude (cheap no-op).
export function filterExcluded(options, exclude) {
  const ids = excludeIdSet(exclude);
  if (!ids.size) {
    return options || [];
  }
  return (options || []).filter(function (option) {
    return !ids.has(option?._id);
  });
}
